var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e285310fb07be6acc89a92cfa16397da.js').default;export default
        Object.assign({}, scope_0 )
    